<template>
  <div class="navBar">
    <slot />
     <ul class="navbarNav">
      <li v-for="link in navLinks" :key="link.name" class="navbarNav__item">
        <router-link :class="cssLinkClass(link.path, link.child)" :to="link.path">
          <i :class="cssIconClass(link.icon)"></i>
          <span :class="`${cssTextClass(link.name)}`">{{ link.name }}</span>
        </router-link>
        <ul v-if="link.child">
          <li v-for="child in link.child" :key="child.name">
            <router-link :class="`navbarNav__childLink ${cssLinkClass(link.path)}`" :to="child.path">
              <i :class="cssIconClass(child.icon)"></i>
              {{ child.name }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NavBar',
  components: {},
  props: {
    isAdmin: Boolean,
    isClientAdmin: Boolean,
    links: {
      type: Array
    }
  },
  methods: {
    cssTextClass (name) {
      return `navbarNav__text navbarNav--${name.toLowerCase()}`
    },
    cssLinkClass (path, child) {
      return `navbarNav__link${this.hasChild(child)}`
    },
    cssIconClass (icon) {
      return `navbarNav__icon menu-icon fa fa-${icon}`
    },
    hasChild (child) {
      return child ? ' navbarNav__hasChildren' : ''
    }
  },
  mounted () {},
  computed: {
    navLinks: function () {
      const invoiceLink = {
        name: 'Invoices',
        path: '/invoices',
        icon: 'book'
      }
      const adminLinks = [
        {
          name: 'Users',
          path: '/users',
          icon: 'users'
        }
      ]
      const links = [
        {
          name: 'Clients',
          path: '/',
          icon: 'building'
        },
        {
          name: 'Links',
          path: '/links',
          icon: 'link'
        },
        {
          name: 'Tags',
          path: '/tags',
          icon: 'tag'
        }
      ]
      if (this.isAdmin || this.isClientAdmin) {
        links.push(invoiceLink)
      }
      if (this.isAdmin) {
        adminLinks.forEach(adminLink => {
          links.push(adminLink)
        })
      }
      return links
    }
  },
  data: () => ({})
}
</script>

<style lang="scss">
    @import "./nav-bar";
</style>



// WEBPACK FOOTER //
// src/components/NavBar/nav-bar.vue